import { Injectable, Injector, inject } from '@angular/core';
import { AuthService, EMBEDDED_AUTH_TIMEOUT_MS, EmbeddedBridgeService, EmbeddedEditorController } from '@infinitform/editor-features';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInitializationService {
  private authService = inject(AuthService);
  private embeddedBridge = inject(EmbeddedBridgeService);
  private injector = inject(Injector);

  async initializeApp(): Promise<void> {
    try {
      this.authService.initializeFromUrl();

      if (this.embeddedBridge.isEmbedded) {
        // Created only when embedded, so the standalone editor boots as before.
        const controller = this.injector.get(EmbeddedEditorController);
        controller.start();
        if (!(await controller.waitForInitialAuth(EMBEDDED_AUTH_TIMEOUT_MS))) {
          this.authService.clearTokens();
        }
        return;
      }

      if (!this.authService.isAuthenticated()) {
        await firstValueFrom(this.authService.refreshToken());
      }
    } catch (error) {
      // Clear invalid user data if refresh fails
      console.error('App initialization failed:', error);
      this.authService.clearTokens();
    }
  }
}
